export class PreviewDirectoryRestoreResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "latestSnapshotId",
            "baseName": "latestSnapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "latestSnapshotTime",
            "baseName": "latestSnapshotTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "relationships",
            "baseName": "relationships",
            "type": "Array<DirectoryMissingRelationship>",
            "format": ""
        },
        {
            "name": "truncated",
            "baseName": "truncated",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PreviewDirectoryRestoreResponse.attributeTypeMap;
    }
    constructor() {
    }
}
